import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { DoctorBase, DoctorResponse } from 'src/app/users/users.model';
import { UserType } from '@shared/Constants/commonConstants';
import { FilterService } from '@shared/service/filter.service';

@Component({
  selector: 'app-doctor-filter',
  templateUrl: './doctor-filter.component.html',
  styleUrls: ['./doctor-filter.component.scss'],
})
export class DoctorFilterComponent implements OnInit {
  @Input() showSelfDoctor?: boolean = true;

  @Input() placeholder: string = 'Select Doctor';

  @Input() doctorControl: FormControl;

  @Output() doctorChanged = new EventEmitter<string>();

  doctorList: DoctorBase[] = [];
  doctorsFilterList: DoctorBase[] = [];

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.loadDoctors();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Detect when parent clears doctorId
    if (changes['doctorControl1'] && this.doctorControl) {
      const ctrl = this.doctorControl;
      if (ctrl.value === null || ctrl.value === '') {
        ctrl.reset();
      }
    }
  }

  loadDoctors(): void {
    const selfDoctor = {
      id: '2',
      name: 'Non-Healic Doctor',
      isDeleted: false,
    } as DoctorBase;

    this.filterService
      .getUsersList<DoctorResponse>(UserType.Doctor, false)
      .subscribe((response) => {
        let doctorConcate = [...response.users];
        if (this.showSelfDoctor) {
          doctorConcate = [selfDoctor, ...response.users];
        }
        this.doctorList = doctorConcate;
        this.doctorsFilterList = [...doctorConcate];
      });
  }

  getDoctorName(): string {
    if (!this.doctorControl) return '';

    const selected = this.doctorsFilterList.find(
      (d) => d.id === this.doctorControl!.value
    );
    return selected ? selected.name : '';
  }

  onSelect(event: any) {
    this.doctorChanged.emit(event.value);
  }
}
